import { object, string } from 'yup';
import { TFunction } from 'i18next';

import { requiredNonNegativeNumberField, requiredString } from 'common/validation';

export function makeFinanceAnalyseSchema(t: TFunction) {
  return object().shape({
    capitalInvesting: requiredNonNegativeNumberField(t),
    liquidity: requiredNonNegativeNumberField(t),
    monthExpenses: requiredNonNegativeNumberField(t),
    monthSalary: requiredNonNegativeNumberField(t),
    disposableResources: requiredString(t),
  });
}
